export const RQ_MEDICINE_ADD_API = {
  url: 'medicine/add',
  method: 'POST',
  auth: true,
};

export const RQ_MEDICINE_UPDATE_API = {
  url: 'medicine/update/<%= medicineId %>',
  method: 'PUT',
  auth: true,
};

export const RQ_MEDICINE_DELETE_API = {
  url: 'medicine/delete/<%= medicineId %>',
  method: 'DELETE',
  auth: true,
};

export const RQ_MEDICINE_GET_API = {
  url: 'medicine/<%= medicineId %>',
  method: 'GET',
  auth: true,
};

export const RQ_MEDICINE_GET_ALL_API = {
  url: 'medicine/all',
  method: 'GET',
  auth: true,
};
